// Datos mock adicionales del rediseño UX desktop (maquetas ChatGPT 2026-07-02).
// Todo estático y sin secretos; alimenta sidebar contextual, raíles laterales y páginas nuevas.

export const savedFilters = [
  { id: "sf1", name: "Para revisar", count: 8 },
  { id: "sf2", name: "IA / ML", count: 24 },
  { id: "sf3", name: "Dev herramientas", count: 17 },
  { id: "sf4", name: "Contenido creador", count: 11 },
  { id: "sf5", name: "Solo vídeos", count: 36 },
];

export const recentSearches = [
  "automatizar facturas",
  "sistemas de IA centrados en el…",
  "traefik vs caddy",
  "gestión del tiempo deep work",
  "prompts para code review",
];

export const searchSuggestions = [
  "automatizar facturas con IA",
  "inspiración UI dark mode",
  "montar un RAG barato",
  "colas de trabajo en Node",
];

export const assistantSuggestions = [
  "Búscame el último vídeo sobre n8n que guardé",
  "Qué guardé sobre RAG y pgvector",
  "Qué contenidos tengo pendientes de revisar",
  "Enséñame ideas para automatizar mi trabajo",
];

export const taskViews = [
  { id: "tv1", name: "Mis pendientes", count: 12 },
  { id: "tv2", name: "Hoy", count: 4 },
  { id: "tv3", name: "Esta semana", count: 8 },
  { id: "tv4", name: "Ideas", count: 9 },
  { id: "tv5", name: "Notas", count: 15 },
];

export const integrations = [
  { id: "int1", name: "Notion", desc: "Envía notas e ideas a tus bases de datos.", connected: true },
  { id: "int2", name: "Google Drive", desc: "Guarda copias de vídeo en tu Drive.", connected: true },
  { id: "int3", name: "Readwise", desc: "Sincroniza tus destacados y resúmenes.", connected: false },
  { id: "int4", name: "Slack", desc: "Comparte contenidos con tu equipo.", connected: false },
  { id: "int5", name: "Webhooks", desc: "Dispara flujos (n8n, Zapier) al capturar.", connected: false },
];

// Uso del plan (card contextual de Ajustes + card Plan)
export const planUsage = {
  storageUsed: "8,2 GB",
  storageTotal: "20 GB",
  storagePct: 41,
  aiQuota: 2000,
  aiUsed: 1248,
};
